import React from "react";
import { Modal } from "react-bootstrap";
import { ShimmerSectionHeader } from "react-shimmer-effects";
import "./modal.css";
import CfdCardItem from "../../CfdCardItem";

const OfferSummaryModal = ({
  showOfferSummaryModal,
  resetOfferSummaryModalState,
  offerSummaryModalState,
  formatPrice,
  item,
  activeTab,
}) => {
  return (
    <Modal
      centered
      className="cfd-disclaimer-modal"
      backdrop="static"
      show={showOfferSummaryModal}
      onHide={resetOfferSummaryModalState}
      dialogClassName="cfd-right-summary-modal-dialog"
      contentClassName="cfd-right-modal-content"
    >
      <Modal.Header closeButton>
        <Modal.Title className="cfd-table-title">CFD Offer Summary</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {offerSummaryModalState.isLoading ? (
          <div className="text-center">
            <ShimmerSectionHeader center />
          </div>
        ) : offerSummaryModalState.error ? (
          <div className="text-center text-danger">
            <p>{offerSummaryModalState.error}</p>
          </div>
        ) : (
          <div className="cfd-make-offer-modal">
            <div className="d-flex">
              <div className="w-60 cfd-offer-info-modal cfd-text-container">
                <p className="cfd-offer-label-modal cfd-summary-text">
                  Offer No
                </p>
                <p className="cfd-offer-amount-modal cfd-summary-left-aligned">
                  {offerSummaryModalState?.propertyData?.offerNumber}
                </p>
              </div>

              <div className="w-40 cfd-offer-info-modal">
                <p className="cfd-offer-label-modal cfd-summary-text">
                  Offer Date
                </p>
                <p className="cfd-offer-amount-modal cfd-summary-left-aligned">
                  {new Date(
                    offerSummaryModalState?.propertyData?.offerDate
                  ).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </p>
              </div>
            </div>

            {offerSummaryModalState.propertyData && (
              <CfdCardItem
                showTags
                isModalOpen
                item={item}
                activeTab={activeTab}
              />
            )}

            <hr className="my-4" />

            <div className="cfd-offer-info-modal">
              <p className="cfd-offer-label-modal">Final Offer Amount:</p>
              <p className="cfd-offer-amount-modal">
                {formatPrice(
                  offerSummaryModalState?.propertyData?.finalOfferAmount
                )}
              </p>
            </div>

            <div className="cfd-offer-info-modal">
              <p
                className="cfd-offer-label-modal"
                style={{
                  textDecoration: "underLine dashed #000",
                  textUnderlineOffset: "5px",
                }}
              >
                Buyer's Premium:
              </p>
              <p
                className="cfd-offer-amount-modal"
                style={{
                  fontFamily: "graphikmedium",
                }}
              >
                {formatPrice(
                  offerSummaryModalState?.propertyData?.buyersPremium
                )}
              </p>
            </div>

            <hr />

            <div className="cfd-offer-info-modal">
              <p
                className="cfd-offer-label-modal"
                style={{
                  textDecoration: "underLine dashed #000",
                  textUnderlineOffset: "5px",
                  fontFamily: "graphikmedium",
                }}
              >
                Total Purchase Price:
              </p>
              <p className="cfd-offer-amount-modal"
                style={{
                  fontFamily: "graphikmedium",
                }}>
                {formatPrice(
                  offerSummaryModalState?.propertyData?.totalPurchasePrice
                )}
              </p>
            </div>
          </div>
        )}
      </Modal.Body>
      {/* <Modal.Footer>
        <button
          className="btn btn-sm btn-thm cfd-btn-thm"
          onClick={resetOfferSummaryModalState}
        >
          Close
        </button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default OfferSummaryModal;
